<template>
  <div class="mb48 orderSearch tms-style">
    <el-card class="mtf1">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="100px" label-position="left" class="custom-el-form">
        <el-form-item :label="$t('AirFreight.CustomerCode')" style="width: 24%">
          <el-input v-model="searchForm.customerNo" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('AirFreight.JobNo')" style="width: 24%">
          <el-input v-model="searchForm.jobNo" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('AirFreight.RangeofBooking')" style="width: 28%">
          <el-date-picker v-model="searchTime" size="small" type="daterange" :picker-options="pickerOptions" class="custom-input" value-format="yyyy-MM-dd" range-separator="~" />
        </el-form-item>
        <el-form-item :label="$t('AirFreight.AirWaybillExpressWaybill')" label-width="130px" style="width: 24%">
          <el-input v-model="searchForm.no" size="small" class="custom-input" />
        </el-form-item>
        <el-form-item :label="$t('AirFreight.PortofOrigin')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.pol" :width="400" @remoteQuery="remoteQuery" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="id" :label="$t('AirFreight.Code')" />
              <el-table-column :property="$t('AirFreight.airport')" :label="$t('AirFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
        <el-form-item :label="$t('AirFreight.PortofDestination')" style="width: 24%">
          <RemoteSelect :value.sync="searchForm.pod" :width="400" @remoteQuery="remoteQuery" @remoteSelect="remoteSelect">
            <template #columns>
              <el-table-column width="100" property="id" :label="$t('AirFreight.Code')" />
              <el-table-column :property="$t('AirFreight.airport')" :label="$t('AirFreight.Name')" />
            </template>
          </RemoteSelect>
        </el-form-item>
      </el-form>
      <div class="custom-flex-center pt10">
        <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" class="custom-el-button" @click="getData">{{ $t('AirFreight.Query') }}</el-button>
        <el-button type="primary" plain size="small" icon="el-icon-refresh-right" :loading="loading" class="custom-el-button" @click="reset">{{ $t('AirFreight.Reset') }}</el-button>
        <el-button type="primary" plain size="small" icon="el-icon-download" :loading="loading" class="custom-el-button" @click="exportData">{{ $t('AirFreight.Export') }}</el-button>
      </div>
    </el-card>
    <el-card class="mt10 custom-el-card">
      <div class="custom-flex-space-between custom-el-card-title">
        <div>{{ $t('AirFreight.ViewDetails') }}</div>
        <el-tooltip class="showType" effect="dark" :open-delay="500" :content="showType ? $t('AirFreight.Switch') : $t('AirFreight.Switch')" placement="bottom">
          <img v-if="showType" src="@/assets/fms/order_list_card.png" @click="showTypeChange">
          <img v-else src="@/assets/fms/order_list_table.png" @click="showTypeChange">
        </el-tooltip>
      </div>
      <el-collapse v-if="showType" v-model="activeNames" v-loading="loading" class="custom-el-collapse">
        <el-collapse-item v-for="i in List" :key="i.jobId" :name="i.jobId">
          <div slot="title" class="custom-el-collapse-item-title custom-flex-space-between">
            <img src="@/assets/fms/订单.png" style="margin-right:18px">
            <div style="flex:1">
              <div class="custom-flex-space-between">
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.CustomerCode') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ i.customerNo }}</span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.JobNo') }}</span> : <span style="color:#67b0c4"><span style="font-size:14px;font-weight: 400;">{{ i.jobNo }}</span></span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.RangeofBooking') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ getcTime(i) }}</span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.AirWaybillExpressWaybill') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ i.no }}</span></div>
              </div>
              <div class="custom-flex-space-between">
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.PortofOrigin') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ getUpper(i.pol) }}</span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.PortofDestination') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ getUpper(i.pod) }}</span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.TotalWeight') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ i.gwt }}{{ i.gwtUnit }}</span></div>
                <div style="width:25%"><span style="font-size:16px">{{ $t('AirFreight.TotalPackage') }}</span> : <span style="font-size:14px;font-weight: 400;">{{ i.pcs }}</span></div>
              </div>
            </div>
            <div>
              <span class="collapsed fr">{{ activeNames.indexOf(i.jobId)>-1 ? $t('AirFreight.Collapse') : $t('AirFreight.ViewDetails') }}</span>
              <br>
              <el-button type="primary" class="custom-el-button details-download" size="mini" @click="downloadAttachment(i)">
                <span><img src="@/assets/fms/下载.png">
                  {{ $t('AirFreight.DownloadAttachment') }}</span>
              </el-button>
            </div>
          </div>
          <div class="custom-el-collapse-item-value custom-flex-space-between">
            <div class="w100">
              <!-- <div class="custom-flex-space-between pdl10">
                <div class="w100">
                  <el-button type="primary" class="custom-el-button details-download" size="mini" @click="downloadAttachment(i)">
                    <span><img src="@/assets/fms/下载.png">
                      {{ $t('AirFreight.DownloadAttachment') }}</span>
                  </el-button>
                </div>
              </div> -->
              <order-step :statu-list="getMilestoneData(i)" />
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-table v-else ref="orderTable" size="mini" v-loading="loading" resizable :data="List" class="selectable">
        <el-table-column type="index" width="50" :index="getIndex" :label="$t('AirFreight.SerialNumber')" />
        <el-table-column prop="customerNo" width="140" :label="$t('AirFreight.CustomerCode')" />
        <el-table-column prop="jobNo" width="140" :label="$t('AirFreight.JobNo')" />
        <el-table-column prop="no" width="140" show-overflow-tooltip :label="$t('AirFreight.AirWaybillExpressWaybill')" />
        <el-table-column prop="status" width="150" show-overflow-tooltip :label="$t('AirFreight.ShipmentStatus')" :formatter="formatStatus" />
        <!-- <el-table-column prop="jobType" width="80" :label="$t('AirFreight.ServiceType')" :formatter="formatjobType" /> -->
        <el-table-column prop="cTime" width="100" :label="$t('AirFreight.BookingDate')" :formatter="formatcTime" />
        <el-table-column prop="pcs" width="80" show-overflow-tooltip :label="$t('AirFreight.TotalPackage')" />
        <el-table-column width="100" show-overflow-tooltip :label="$t('AirFreight.TotalWeight')">
          <template slot-scope="scope">
            <span>{{ scope.row.gwt }} {{ scope.row.gwtUnit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pol" min-width="120" show-overflow-tooltip :label="$t('AirFreight.PortofOrigin')" :formatter="formatUpper" />
        <el-table-column prop="pod" min-width="120" show-overflow-tooltip :label="$t('AirFreight.PortofDestination')" :formatter="formatUpper" />
        <el-table-column width="80" :label="$t('AirFreight.Operation')">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="downloadAttachment(scope.row)">
                {{ $t('AirFreight.Download') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="footPage">
      <el-pagination class="custom-el-pagination floatR" background layout="sizes, prev, pager, next" :total="Total" :page-size="PageSize" :page-sizes="[10, 20, 50, 100]" :current-page="PageIndex" @current-change="currentChange" @size-change="sizeChange" />
    </div>
    <attachment-dialog v-if="attachmentDialogShow" :visible.sync="attachmentDialogShow" :title="curTitle" :cur-row="curRow" />
  </div>
</template>
<script>
import { GetOrderPage, GetAirProts } from '@/api/air/order/index.js'
import orderStep from '@/components/fms/orderStep/index.vue'
import { parseTime, dateAdds } from '@/utils/index.js'
import attachmentDialog from '@/components/fms/Dialog/attachmentDialog.vue'
import { exportToExcel } from '@/components/fms/vendor/Export2Excel.js'
import RemoteSelect from '@/components/fms/remoteSelect.vue'
import i18n from '@/i18n/i18n'
export default {
  components: { orderStep, attachmentDialog, RemoteSelect },
  props: {
    jobType: {
      type: String,
      default: 'AE'
    }
  },
  data() {
    return {
      searchForm: {
        jobNo: '',
        no: '',
        customerNo: '',
        pol: '',
        pod: ''
      },
      showType: true,
      activeNames: [],
      // jobType: 'AE',
      // selectList: [
      //   { value: 'AE', label: '空运出口' },
      //   { value: 'AI', label: '空运进口' }
      // ],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      List: [],
      loading: false,
      searchTime: [
        parseTime(dateAdds(new Date(), -30, 'd'), '{y}-{m}-{d}'),
        parseTime(new Date(), '{y}-{m}-{d}')
      ],
      disabledDateRange: [],
      pickerOptions: {
        disabledDate: (time) => {
          if (this.disabledDateRange && this.disabledDateRange.length > 0) {
            return (
              time.getTime() < this.disabledDateRange[0].getTime() ||
              time.getTime() > this.disabledDateRange[1].getTime()
            )
          } else {
            return false
          }
        },
        onPick: (picks) => {
          if (picks.maxDate) {
            this.disabledDateRange = []
          } else {
            this.disabledDateRange = [
              dateAdds(picks.minDate, -30, 'd'),
              dateAdds(picks.minDate, 30, 'd')
            ]
          }
        }
      },
      attachmentDialogShow: false,
      curRow: {},
      curTitle: this.$t('AirFreight.DownloadAttachment'),
      loadingInstance: {}
    }
  },
  computed: {},
  watch: {
    jobType (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getData()
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getIndex(index) {
      return (this.PageIndex - 1) * this.PageSize + index + 1
    },
    showTypeChange() {
      this.showType = !this.showType
      this.getData()
    },
    async getData() {
      const defaultData = {
        pageIndex: this.PageIndex,
        pageSize: this.PageSize,
        searchTimes: this.searchTime.join('至'),
        jobType: this.jobType
      }
      const data = JSON.parse(
        JSON.stringify(Object.assign(defaultData, this.searchForm))
      )
      this.List = []
      this.loading = true
      const res = await GetOrderPage(data)
      this.loading = false
      if (res && res.isSuccess) {
        this.List = res.data.data
        this.Total = res.data.totalCount
        this.activeNames = res.data.data.map((x) => x.jobId)
      }
    },
    /** Milestone 节点 */
    getMilestoneData(item) {
      const data = []
      if (item.jobType === 'AE') {
        data.push({
          Name: this.$t('AirFreight.PuttinginwarehouseTime'),
          EventDT: item.sInboundDt,
          OpenImg: require('@/assets/fms/入库.png'),
          ShutImg: require('@/assets/fms/入库—灰.png')
        })
        data.push({
          Name: this.$t('AirFreight.TimeofDeparture'),
          EventDT: item.sBeginDt,
          OpenImg: require('@/assets/fms/起飞.png'),
          ShutImg: require('@/assets/fms/起飞—灰.png')
        })
        data.push({
          Name: this.$t('AirFreight.TimeofArrival'),
          EventDT: item.sEndDt,
          OpenImg: require('@/assets/fms/到达.png'),
          ShutImg: require('@/assets/fms/到达—灰.png')
        })
      } else if (item.jobType === 'AI') {
        data.push({
          Name: this.$t('AirFreight.SBookingReceipt'),
          EventDT: item.sBookingReceipt,
          DivsvgStyle: 'padding:5px',
          OpenImg: require('@/assets/fms/接单.png'),
          ShutImg: require('@/assets/fms/接单—灰.png')
        })
        data.push({
          Name: this.$t('AirFreight.SBeginDt'),
          EventDT: item.sBeginDt,
          OpenImg: require('@/assets/fms/到港.png'),
          ShutImg: require('@/assets/fms/到港—灰.png')
        })
        data.push({
          Name: this.$t('AirFreight.SCustomsReleased'),
          EventDT: item.sCustomsReleased,
          DivsvgStyle: 'padding:5px',
          OpenImg: require('@/assets/fms/放行（空）.png'),
          ShutImg: require('@/assets/fms/放行（空）—灰.png')
        })
        data.push({
          Name: this.$t('AirFreight.SpoDupload'),
          EventDT: item.spoDupload,
          OpenImg: require('@/assets/fms/签收.png'),
          ShutImg: require('@/assets/fms/签收—灰.png')
        })
      }
      return data
    },
    currentChange(PageIndex) {
      this.PageIndex = PageIndex
      this.getData()
    },
    sizeChange(PageSize) {
      this.PageIndex = 1
      this.PageSize = PageSize
      this.getData()
    },
    searchTimeChange() {
      this.getData()
    },
    reset() {
      this.searchForm.jobNo = ''
      this.searchForm.no = ''
      this.searchForm.customerNo = ''
      this.searchForm.pol = ''
      this.searchForm.pod = ''

      this.searchTime = [
        parseTime(dateAdds(new Date(), -30, 'd'), '{y}-{m}-{d}'),
        parseTime(new Date(), '{y}-{m}-{d}')
      ]
      this.getData()
    },
    /** 导出 */
    async exportData() {
      try {
        this.loading = true
        let jobType = 'AI'
        // 导出全部页
        const defaultData = {
          pageIndex: 1,
          pageSize: this.Total > 0 ? this.Total : this.pageSize,
          searchTimes: this.searchTime.join('至'),
          jobType: this.jobType
        }
        const data = JSON.parse(
          JSON.stringify(Object.assign(defaultData, this.searchForm))
        )
        const res = await GetOrderPage(data)
        if (!res || !res.isSuccess) {
          return
        }
        // 转换数据为工作表对象
        var dataList = res.data.data.map((x) => {
          jobType = x.jobType
          if (x.jobType === 'AE') {
            return {
              customerNo: x.customerNo,
              jobNo: x.jobNo,
              no: x.no,
              status: this.formatStatus(x, { property: 'status' }),
              // jobType: this.formatjobType(x, { property: 'jobType' }),
              cTime: x.cTime,
              pcs: x.pcs,
              gwt: x.gwt + ' ' + x.gwtUnit,
              pol: x.pol,
              pod: x.pod,
              sInboundDt: x.sInboundDt,
              sBeginDt: x.sBeginDt,
              sEndDt: x.sEndDt
            }
          } else {
            return {
              customerNo: x.customerNo,
              jobNo: x.jobNo,
              no: x.no,
              status: this.formatStatus(x, { property: 'status' }),
              // jobType: this.formatjobType(x, { property: 'jobType' }),
              cTime: x.cTime,
              pcs: x.pcs,
              gwt: x.gwt + ' ' + x.gwtUnit,
              pol: x.pol,
              pod: x.pod,
              sBookingReceipt: x.sBookingReceipt,
              sBeginDt: x.sBeginDt,
              sCustomsReleased: x.sCustomsReleased,
              spoDupload: x.spoDupload
            }
          }
        })
        const column = [
          { lable: this.$t('AirFreight.CustomerCode'), width: 20 },
          { lable: this.$t('AirFreight.JobNo'), width: 20 },
          { lable: this.$t('AirFreight.AirWaybillExpressWaybill'), width: 20 },
          { lable: this.$t('AirFreight.ShipmentStatus'), width: 15 },
          // { lable: this.$t('AirFreight.ServiceType'), width: 10 },
          { lable: this.$t('AirFreight.BookingDate'), width: 20 },
          { lable: this.$t('AirFreight.TotalPackage'), width: 10 },
          { lable: this.$t('AirFreight.TotalWeight'), width: 20 },
          { lable: this.$t('AirFreight.PortofOrigin'), width: 20 },
          { lable: this.$t('AirFreight.PortofDestination'), width: 20 }
        ]
        if (jobType === 'AE') {
          column.push({
            lable: this.$t('AirFreight.PuttinginwarehouseTime'),
            width: 20
          })
          column.push({
            lable: this.$t('AirFreight.TimeofDeparture'),
            width: 20
          })
          column.push({ lable: this.$t('AirFreight.TimeofArrival'), width: 20 })
        } else {
          column.push({
            lable: this.$t('AirFreight.SBookingReceipt'),
            width: 20
          })
          column.push({ lable: this.$t('AirFreight.SBeginDt'), width: 20 })
          column.push({
            lable: this.$t('AirFreight.SCustomsReleased'),
            width: 20
          })
          column.push({ lable: this.$t('AirFreight.SpoDupload'), width: 20 })
        }
        if (dataList && dataList.length > 0) {
          exportToExcel({
            column,
            dataList,
            filename:
              (jobType === 'AE'
                ? this.$t('AirFreight.AEDetails')
                : this.$t('AirFreight.AIDetails')) +
              parseTime(new Date(), '_{y}{m}{d}')
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
    downloadAttachment(i) {
      this.curTitle = this.$t('AirFreight.DownloadAttachment') + ' ' + i.jobNo
      this.curRow = i
      this.attachmentDialogShow = true
    },
    formatjobType(row, column) {
      return row[column.property] === 'AE'
        ? i18n.t('AirFreight.AirFreightExport')
        : row[column.property] === 'AI'
        ? i18n.t('AirFreight.AirFreightImport')
        : ''
    },
    formatStatus(row, column) {
      switch (row[column.property]) {
        case '到达':
          return i18n.t('AirFreight.TimeofArrival')
        case '起飞':
          return i18n.t('AirFreight.TimeofDeparture')
        case '入库':
          return this.$t('AirFreight.PuttinginwarehouseTime')
        case '签收':
          return this.$t('AirFreight.SpoDupload')
        case '放行':
          return this.$t('AirFreight.SCustomsReleased')
        case '到港':
          return this.$t('AirFreight.SBeginDt')
        case '接单':
          return this.$t('AirFreight.SBookingReceipt')
        default:
          return ''
      }
    },
    formatcTime(row, column) {
      return parseTime(row[column.property], '{y}-{m}-{d}')
    },
    formatUpper(row, column) {
      if (row[column.property]) {
        return row[column.property].toUpperCase()
      } else return ''
    },
    getcTime(i) {
      return parseTime(i.cTime, '{y}-{m}-{d}')
    },
    getUpper(i) {
      if (i) return i.toUpperCase()
      else return ''
    },
    async remoteQuery(query, call) {
      const res = await GetAirProts({ KeyWord: query })
      if (call) {
        if (res.isSuccess) {
          call(res.data)
        } else {
          call([])
        }
      }
    },
    remoteSelect(row, call) {
      if (call) {
        call(row.airportEname)
      }
    }
  }
}
</script>
<style scoped>
.fr {
  float: right;
}
.orderSearch >>> .el-date-editor .el-range-separator {
  width: initial;
  display: block;
}
.orderSearch >>> .el-table .el-table__cell {
  padding: initial;
}
.custom-el-form {
  padding: 0 16px;
}
.custom-el-form > .el-form-item {
  width: 25%;
  margin: 0;
  padding-top: 10px;
  padding-right: 10px;
  display: inline-flex;
}
.custom-el-form > .el-form-item >>> .el-form-item__content {
  flex: 1;
}
.custom-el-form >>> .el-input__inner {
  max-width: initial;
}
.custom-input {
  width: 100%;
  display: inline-flex;
  background: #fff;
  border-radius: 5px;
}
.custom-input >>> input {
  background: #fff !important;
  flex: 1;
}
.custom-input.el-date-editor {
  background: #fff;
}
.custom-input.el-date-editor >>> .el-input__icon {
  display: none;
}
.selectable >>> th {
  user-select: auto;
}
.selectable >>> .el-table__row {
  height: 30px;
}
.custom-el-card {
  border: 0;
}
.custom-el-card >>> .el-card__body {
  padding: 0px;
}
.custom-el-card-title {
  border-radius: 4px 4px 0 0;
  border: 1px solid #ebeef5;
  border-bottom: 0;
  padding: 10px 20px;
  font-size: 16px;
  line-height: 20px;
}
.custom-el-collapse {
  border: 0;
  background-color: aliceblue;
  box-shadow: none;
}
.custom-el-collapse > .el-collapse-item {
  border-radius: 4px;
  border: 1px solid #ebeef5;
  margin-bottom: 10px;
}
.custom-el-collapse >>> .el-collapse-item__header {
  border-radius: 4px;
  border: 0;
  height: auto;
  font-size: 14px;
}
.custom-el-collapse >>> .el-collapse-item__wrap {
  border-radius: 0 0 4px 4px;
  border: 0;
  border-top: 1px solid #ebeef5;
}
.custom-el-collapse >>> .el-collapse-item__content {
  padding: 0;
}
.custom-el-collapse-item-title {
  width: 100%;
  line-height: 30px;
  padding: 30px 36px;
}

.custom-el-collapse img {
  width: 24px;
  height: 30px;
  line-height: 30px;
}
.custom-el-collapse-item-value {
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 10px 36px;
  border-radius: 8px;
}
.custom-jobtype {
  border-radius: 10px;
  width: 80px;
  display: inline-block;
  line-height: 22px;
  text-align: center;
}
.details-title {
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 24px;
  margin-bottom: 13px;
}
.details-label {
  width: 93px;
  display: inline-block;
  font-weight: 500;
}
.details-download {
  display: block;
  float: right;
  width: 102px;
}
.details-download img {
  width: 14px;
  height: 14px;
  margin-right: 5px;
  line-height: 14px;
}
.inline-block {
  display: inline-block;
}
.showType {
  width: 20px;
  height: 20px;
}
.footPage {
  background-color: #fff;
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 36px;
  padding: 8px 16px;
}
.loadingClass {
  height: 50px;
}
.custom-el-collapse >>> .el-collapse-item__arrow {
  display: none !important;
}
.collapsed {
  width: 56px;
  font-size: 14px;
  color: #67b0c4;
  line-height: 30px;
  text-align: center;
}
.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mt10 {
  margin-top: 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.ml18 {
  margin-left: 18px;
}
.ml52 {
  margin-left: 52px;
}
.mb48 {
  margin-bottom: 48px;
}
.pdl10 {
  padding-left: 10px;
}
.pt10 {
  padding-top: 20px;
}
.pb10 {
  padding-bottom: 10px;
}
.w100 {
  width: 100%;
}
.w50 {
  width: 50%;
}
.w30 {
  width: 30%;
}
.w20 {
  width: 20%;
}
.floatR {
  float: right;
}
</style>
